<template>
  <v-sheet elevation="0" width="100%" class="pa-3" style="margin-bottom: 1px; background-color: #CFD8DC;">
    <div>Name: <b>{{name}}</b></div>
    <div>State: <b>{{state}}</b></div>
    <!--
    <div>Current Step: <b>{{currentStep}}</b></div>
    <div>Step Count: <b>{{stepCount}}</b></div>
    -->
    <div>Passed: <b>{{passed}}</b></div>
    <div>Report Message: <b>{{reportMessage || 'None'}}</b></div>
  </v-sheet>
</template>

<script>

export default {
  props: {
    name: String,
    state: String,
    //currentStep: Number,
    //stepCount: Number,
    passed: Boolean,
    reportMessage: String,
  },

  methods: {
  },
};
</script>
